export const GET_TOKEN = "get-token";
export const GET_VIOLATION_DATA = "getViolation";
export const GET_UNLOCK_CODE_BY_PAYMENT = "payment";
export const GET_PAYMENT_RECEIPT_LINK = "download-pdf";
export const SUBMIT_CONTACT_US = "contact";
export const GET_VIOLATION_DETAILS = "getViolationDetail";
export const GET_REMOVAL_INSTRUCTION = "property/boot-release/detail";
export const GET_FIRMWARE = "checkFirmwareVersion";
export const POST_PAYMENT_AUTHORIZEDOTNET = "make-violation-payment";
export const UPLOAD_LOCK_IMAGE = "upload-violation-lock-image";
